import React, { useEffect, useState } from "react";
import { api } from "@/api/client.js";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function GroupPage() {
  const { ui } = useOrignalUi();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api("/api/members").then((d) => setItems(d.items)).catch(() => {});
  }, []);

  const official = items.filter((m) => (m.kind || "official") === "official");
  const associated = items.filter((m) => m.kind === "associated");

  function roleOf(m) {
    if (m.trip_role === "organizer") return ui.group.organizer;
    if (m.trip_role === "hunter") return ui.group.hunter;
    if (m.kind === "associated") return ui.group.associated;
    return m.role === "admin" ? ui.group.admin : ui.group.member;
  }

  return (
    <main className="og-cockpit og-cockpit--group" data-testid="page-group">
      <section className="og-panel">
        <h1>{ui.hunt.groupHunt}</h1>
        <p className="og-lead" data-testid="group-official">{ui.hunt.sixHunters}</p>
        <div className="og-member-grid">
          {official.map((m) => (
            <article key={m.id} className="og-member-card">
              <span className="og-avatar og-avatar--lg" style={{ background: m.color }}>{m.initials}</span>
              <strong>{m.display_name || `${m.first_name} ${m.last_name || ""}`}</strong>
              <small>{roleOf(m)}</small>
            </article>
          ))}
        </div>
      </section>
      <aside className="og-panel" data-testid="associated-panel">
        <h2 data-testid="group-associated">{ui.group.associatedTitle || ui.group.associated} — {associated.length}</h2>
        {associated.map((m) => (
          <p key={m.id}>
            <strong>{m.display_name || m.first_name}</strong>
            {m.duty === "food_coordinator" ? ` · ${ui.group.foodLead}` : m.associated_of ? ` · ${m.associated_of}` : ""}
          </p>
        ))}
      </aside>
    </main>
  );
}
